import { z } from 'zod';
export const FootprintSectionSchema = z.object({
    summary: z.string(),
    details: z.array(z.string())
});
export const DigitalFootprintFindingsSchema = z.object({
    content_category_flags: FootprintSectionSchema,
    traffic_analysis: FootprintSectionSchema,
    ecosystem_links: FootprintSectionSchema,
    hosting_domain_age: FootprintSectionSchema,
    compliance_page_issues: FootprintSectionSchema
}).meta({
    id: 'DigitalFootprintFindings'
});

//# sourceMappingURL=digital-footprint-findings.schema.js.map